import { Estimate, Project } from '../../../entities/task/model/types/tasks';
import { SelectedItem } from '../types/taskHeader';
import { getProjectAndEstimates } from './getProjectAndEstimates';

export const searcher = (projectsForFilter: Project[], search: string): SelectedItem[] => {
    const result: Project[] = [];

    projectsForFilter.forEach((project) => {
        const { estimates, ...projectData } = project;

        if (projectData.name.toLowerCase().includes(search.toLowerCase())) {
            result.push(project);
        } else {
            const searchedEstimates: Estimate[] = estimates.filter((estimate) =>
                estimate.name.toLowerCase().includes(search.toLowerCase())
            );
            if (!!searchedEstimates.length) {
                result.push({
                    ...projectData,
                    estimates: searchedEstimates,
                });
            }
        }
    });

    return getProjectAndEstimates(result);
};
